import { contrastChart } from '@iq/react-components';

const RollingAveragePlot = ({ rollingPlot, configuration }) => (
  <g
    name="rolling-plot"
    style={{ pointerEvents: 'none' }}
  >
    {rollingPlot.data.length &&
      rollingPlot.data.map((value, i) => {
        if (configuration.rollingAverage?.type === 'Lines') {
          if (i === rollingPlot.data.length - 1) {
            return null;
          }
          return (
            <line
              key={i}
              x1={value.X}
              y1={value.Y}
              x2={rollingPlot.data[i + 1].X}
              y2={rollingPlot.data[i + 1].Y}
              stroke={rollingPlot.color || contrastChart[1]}
              strokeWidth={configuration.pointRadius / 3}
              opacity={((100 / rollingPlot.data.length) * i) / 100}
            />
          );
        }
        if (configuration.rollingAverage?.type === 'Both') {
          return (
            <g key={i}>
              {i !== rollingPlot.data.length - 1 && (
                <line
                  x1={value.X}
                  y1={value.Y}
                  x2={rollingPlot.data[i + 1].X}
                  y2={rollingPlot.data[i + 1].Y}
                  stroke={rollingPlot.color || contrastChart[1]}
                  strokeWidth={configuration.pointRadius / 3}
                  opacity={((100 / rollingPlot.data.length) * i) / 100}
                />
              )}
              <circle
                cx={value.X}
                cy={value.Y}
                r={configuration.pointRadius / 2}
                opacity={((100 / rollingPlot.data.length) * i) / 100}
                fill={rollingPlot.color || contrastChart[1]}
                stroke=""
              />
            </g>
          );
        }

        return (
          <circle
            key={i}
            cx={value.X}
            cy={value.Y}
            r={configuration.pointRadius / 2}
            opacity={((100 / rollingPlot.data.length) * i) / 100}
            fill={rollingPlot.color || contrastChart[1]}
            stroke=""
          />
        );
      })}
  </g>
);

export default RollingAveragePlot;
